import SvgAgentClientIcon from "../../assets/agentIcon/SvgAgentClientIcon";
import SvgAgentHomeIcon from "../../assets/agentIcon/SvgAgentHomeIcon";
import SvgAgentItemsIcon from "../../assets/agentIcon/SvgAgentItemsIcon";
import SvgAgentLeadIcon from "../../assets/agentIcon/SvgAgentLeadIcon";
import SvgAgentPaymentIcon from "../../assets/agentIcon/SvgAgentPaymentIcon";
import SvgClient from "../../assets/agentIcon/SvgClient";
import SvgLead from "../../assets/agentIcon/SvgLead";
import SvgPaymentIcon from "../../assets/agentIcon/SvgPaymentIcon";
import SvgPolicyIcon from "../../assets/agentIcon/SvgPolicyIcon";
import SvgQuotationIcon from "../../assets/agentIcon/SvgQuotationIcon";
import SvgAccountIcon from "../../assets/icons/SvgAccountIcon";
import SvgMassterIcon from "../../assets/icons/SvgMassterIcon";
import SvgReportsIcon from "../../assets/icons/SvgReportsIcon";
import { useParams } from "react-router-dom";

export const menuList = [
  {
    name: "Master",
    icon: <SvgMassterIcon />,
    submenu: [
      {
        id: 1,
        name: "Generals",
        submenu: [
          {
            id: 1,
            name: "Organization",
            path: "/master/generals/organization",
            submenu: [
              {
                id: 1,
                name: "Company",
                path: "/master/generals/organization/companymaster",
                includes: [
                  "/master/generals/organization/companymaster",
                  "/master/generals/organization/companymaster/add/",
                  "/master/generals/organization/companymaster/edit/",
                  "/master/generals/organization/companymaster/view/",
                ],
              },

              {
                id: 2,
                name: "Branch",
                path: "/master/generals/organization/branchmaster",
                includes: [
                  "/master/generals/organization/branchmaster",
                  "/master/generals/organization/branchmaster/add/",
                  "/master/generals/organization/branchmaster/edit/",
                  "/master/generals/organization/branchmaster/view/",
                ],
              },
            ],
          },
          {
            id: 2,
            name: "Insurance Management",
            path: "/master/generals/organization",
            submenu: [
              {
                id: 1,
                name: "Insurance Company",
                path: "/master/generals/insurancemanagement/insurancecompany",
                includes: [
                  "/master/generals/insurancemanagement/insurancecompany",
                  "/master/generals/insurancemanagement/insurancecompany/add/",
                  "/master/generals/insurancemanagement/insurancecompany/edit/",
                  "/master/generals/insurancemanagement/insurancecompany/view/",
                ],
              },
              {
                id: 2,
                name: "Line of Business",
                path: "/master/generals/insurancemanagement/lineofbusiness",
                includes: [
                  "/master/generals/insurancemanagement/lineofbusiness",
                  "/master/generals/insurancemanagement/lineofbusiness/add/",
                  "/master/generals/insurancemanagement/lineofbusiness/edit/",
                  "/master/generals/insurancemanagement/lineofbusiness/view/",
                ],
              },
              {
                id: 3,
                name: "Product",
                path: "/master/generals/insurancemanagement/productmaster",
                includes: [
                  "/master/generals/insurancemanagement/productmaster",
                  "/master/generals/insurancemanagement/productmaster/add/",
                  "/master/generals/insurancemanagement/productmaster/edit/",
                  "/master/generals/insurancemanagement/productmaster/view/",
                ],
              },
              // {
              //   id: 4,
              //   name: "Policy Type",
              //   path: "/master/generals/insurancemanagement/policytype",
              // },
              {
                id: 5,
                name: "Cover",
                path: "/master/generals/insurancemanagement/cover",
                includes: [
                  "/master/generals/insurancemanagement/cover",
                  "/master/generals/insurancemanagement/cover/add/",
                  "/master/generals/insurancemanagement/cover/view/",
                  "/master/generals/insurancemanagement/cover/edit/",
                ],
              },
              {
                id: 6,
                name: "Signatories",
                path: "/master/generals/insurancemanagement/signatories",
                includes: [
                  "/master/generals/insurancemanagement/signatories",
                  "/master/generals/insurancemanagement/signatories/add/",
                  "/master/generals/insurancemanagement/signatories/edit/",
                  "/master/generals/insurancemanagement/signatories/view/",
                ],
              },
              {
                id: 7,
                name: "Vehicle",
                path: "/master/generals/insurancemanagement/vehicle",
                includes: [
                  "/master/generals/insurancemanagement/vehicle",
                  "/master/generals/insurancemanagement/vehicle/add/",
                  "/master/generals/insurancemanagement/vehicle/edit/",
                  "/master/generals/insurancemanagement/vehicle/view/",
                ],
              },
            ],
          },
          {
            id: 3,
            name: "Location",
            path: "/master/generals/organization",
            submenu: [
              {
                id: 1,
                name: "Country",
                path: "/master/generals/location/country",
                includes: [
                  "/master/generals/location/country",
                  "/master/generals/location/country/add",
                  "/master/generals/location/country/edit",
                  "/master/generals/location/country/view",
                ],
              },
              {
                id: 2,
                name: "State",
                path: "/master/generals/location/state",
                includes: [
                  "/master/generals/location/state",
                  "/master/generals/location/state/add",
                  "/master/generals/location/state/edit",
                  "/master/generals/location/state/view",
                ],
              },
              {
                id: 3,
                name: "City Master",
                path: "/master/generals/location/city",
                includes: [
                  "/master/generals/location/city",
                  "/master/generals/location/city/add",
                  "/master/generals/location/city/edit",
                  "/master/generals/location/city/view",
                ],
              },
            ],
          },
          {
            id: 4,
            name: "Commission",
            path: "/master/generals/commission",
            includes: [
              "/master/generals/commission",
              "/master/generals/commission/addcommission",
              "/master/generals/commission/editcommission",
              "/master/generals/commission/viewcommission/",
            ],
          },
          {
            id: 5,
            name: "Employee Management",
            path: "/master/generals/organization",
            submenu: [
              {
                id: 1,
                name: "Hierarchy",
                path: "/master/generals/employeemanagement/hierarchy",
                includes: [
                  "/master/generals/employeemanagement/hierarchy",
                  "/master/generals/employeemanagement/hierarchy/add",
                  "/master/generals/employeemanagement/hierarchy/edit/",
                  "/master/generals/employeemanagement/hierarchy/view/",
                ],
              },
              {
                id: 2,
                name: "Designation",
                path: "/master/generals/employeemanagement/designation",
                includes: [
                  "/master/generals/employeemanagement/designation",
                  "/master/generals/employeemanagement/designation/add/",
                  "/master/generals/employeemanagement/designation/edit/",
                  "/master/generals/employeemanagement/designation/view/",
                ],
              },
              {
                id: 3,
                name: "Employee",
                path: "/master/generals/employeemanagement/employee",
                includes: [
                  "/master/generals/employeemanagement/employee",
                  "/master/generals/employeemanagement/employee/add/",
                  "/master/generals/employeemanagement/employee/edit/",
                  "/master/generals/employeemanagement/employee/view/",
                ],
              },
            ],
          },
          {
            id: 6,
            name: "User Management",
            path: "/master/generals/organization",
            submenu: [
              {
                id: 1,
                name: "User",
                path: "/master/generals/usermanagement/user",
                includes: [
                  "/master/generals/usermanagement/user",
                  "/master/generals/usermanagement/user/add",
                  "/master/generals/usermanagement/user/edit/",
                  "/master/generals/usermanagement/user/view/",
                ],
              },
              {
                id: 2,
                name: "Role",
                path: "/master/generals/usermanagement/role",
                includes: [
                  "/master/generals/usermanagement/role",
                  "/master/generals/usermanagement/role/add/",
                  "/master/generals/usermanagement/role/edit/",
                  "/master/generals/usermanagement/role/view/",
                ],
              },
            ],
          },
        ],
      },
      {
        id: 2,
        name: "Finance",
        submenu: [
          {
            id: 1,
            name: "Transaction code",
            path: "/master/finance/transactioncode",
            includes: [
              "/master/finance/transactioncode",
              "/master/finance/transactioncode/addtransactioncode",
              "/master/finance/transactioncode/transactioncodeedit",
              "/master/finance/transactioncode/transactioncodedetails",
            ],
          },
          {
            id: 2,
            name: "Currency",
            path: "/master/finance/currency",
            includes: [
              "/master/finance/currency",
              "/master/finance/currency/addcurrency",
              "/master/finance/currency/editcurrency",
              "/master/finance/currency/viewcurrency",
            ],
          },
          {
            id: 3,
            name: "Exchange Rate",
            path: "/master/finance/exchangerate",
            includes: [
              "/master/finance/exchangerate",
              "/master/finance/exchangerate/addexchange",
              "/master/finance/exchangerate/saveandeditexchange",
              "/master/finance/exchangerate/viewexchange",
            ],
          },
          {
            id: 4,
            name: "Bank",
            path: "/master/finance/bank",
            includes: [
              "/master/finance/bank",
              "/master/finance/bank/addbankmaster",
              "/master/finance/bank/accountdataview",
              "/master/finance/bank/accountdataview/addaccountdetail",
              "/master/finance/bank/accountdataview/viewaccountdetail",
              "/master/finance/bank/accountdataview/editaccountdetail",
            ],
          },
          {
            id: 5,
            name: "Account Category",
            path: "/master/finance/accountcategory",
            includes: ["/master/finance/accountcategory"],
          },
          {
            id: 6,
            name: "Main Account",
            path: "/master/finance/mainaccount",
            includes: [
              "/master/finance/mainaccount",
              "/master/finance/mainaccount/addmainaccount",
              "/master/finance/mainaccount/editmainaccount",
              "/master/finance/mainaccount/viewmainaccount",
            ],
          },
          {
            id: 7,
            name: "Sub Account",
            path: "/master/finance/subaccount",
            includes: [
              "/master/finance/subaccount",
              "/master/finance/subaccount/subaccountedit",
              "/master/finance/subaccount/subaccountdetails",
            ],
          },
          {
            id: 8,
            name: "Taxation",
            path: "/master/finance/taxation",
            includes: [
              "/master/finance/taxation",
              "/master/finance/taxation/addtaxation",
              "/master/finance/taxation/taxationedit",
              "/master/finance/taxation/taxationdetails",
            ],
          },
          {
            id: 9,
            name: "Petty cash",
            path: "/master/finance/pettycash",
            includes: [
              "/master/finance/pettycash",
              "/master/finance/pettycash/addpettycash",
              "/master/finance/pettycash/editpettycash/",
              "/master/finance/pettycash/pettycashdetail/",
            ],
          },
          {
            id: 10,
            name: "Remittance Master",
            path: "/master/finance/remittance",
            includes: [
              "/master/finance/remittance",
              "/master/finance/remittance/automatedremittance/add",
              "/master/finance/remittance/automatedremittance/edit",
              "/master/finance/remittance/automatedremittance/view",
              "/master/finance/remittance/statementtemplate/add",
              "/master/finance/remittance/statementtemplate/edit",
              "/master/finance/remittance/statementtemplate/view",
              "/master/finance/remittance/settlementparameter/add",
              "/master/finance/remittance/settlementparameter/edit",
              "/master/finance/remittance/settlementparameter/view",
              "/master/finance/remittance/reconciliationmaster/add",
              "/master/finance/remittance/reconciliationmaster/edit",
              "/master/finance/remittance/reconciliationmaster/view",
              "/master/finance/remittance/bulkprocessingmaster/add",
              "/master/finance/remittance/bulkprocessingmaster/edit",
              "/master/finance/remittance/bulkprocessingmaster/view",
              "/master/finance/remittance/schedulemaster/add",
              "/master/finance/remittance/schedulemaster/edit",
              "/master/finance/remittance/schedulemaster/view",
              "/master/finance/remittance/electronictransfermaster/add",
              "/master/finance/remittance/electronictransfermaster/edit",
              "/master/finance/remittance/electronictransfermaster/view",
              "/master/finance/remittance/approvalworkflowmaster/add",
              "/master/finance/remittance/approvalworkflowmaster/edit",
              "/master/finance/remittance/approvalworkflowmaster/view",
              "/master/finance/remittance/exceptionmaster/add",
              "/master/finance/remittance/exceptionmaster/edit",
              "/master/finance/remittance/exceptionmaster/view",
              "/master/finance/remittance/reporttemplatemaster/add",
              "/master/finance/remittance/reporttemplatemaster/edit",
              "/master/finance/remittance/reporttemplatemaster/view",
              "/master/finance/remittance/agencybillmaster/add",
              "/master/finance/remittance/agencybillmaster/edit",
              "/master/finance/remittance/agencybillmaster/view",
              "/master/finance/remittance/directbillmaster/add",
              "/master/finance/remittance/directbillmaster/edit",
              "/master/finance/remittance/directbillmaster/view",
              "/master/finance/remittance/adjustmentmaster/add",
              "/master/finance/remittance/adjustmentmaster/edit",
              "/master/finance/remittance/adjustmentmaster/view",
              "/master/finance/remittance/notificationmaster/add",
              "/master/finance/remittance/notificationmaster/edit",
              "/master/finance/remittance/notificationmaster/view",
              "/master/finance/remittance/historyconfiguration/add",
              "/master/finance/remittance/historyconfiguration/edit",
              "/master/finance/remittance/historyconfiguration/view",
              "/master/finance/remittance/analyticsconfiguration/add",
              "/master/finance/remittance/analyticsconfiguration/edit",
              "/master/finance/remittance/analyticsconfiguration/view",
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Operations",
    icon: <SvgReportsIcon />,
    submenu: [
      {
        name: "Home",
        icon: <SvgAgentHomeIcon color="#9DA4AE" />,
        path: "/",
        includes: [
          "/",
          "/agent/notification",
          "/agent/viewprofile",
          "/agent/openitems",
          "/agent/openitems/upcomingevents",
        ],
      },
      {
        name: "Leads/Prospects",
        icon: <SvgAgentLeadIcon color="#9DA4AE" />,
        path: "/agent/leadlisting",
        includes: [
          "/agent/createlead/employee-benefit",
          "/agent/leadlisting",
          "/agent/createlead",
          "/createquote/policydetails/createquote/",
          "/createquote/coveragedetails/coveragecreate/",
          "/createquote/accessories/accessoriescreate/",
          "/agent/createquote/ordersummary",
          "/agent/quotedetailview",
          "/agent/convertpolicy/customerinfo/view/",
          "/agent/convertpolicy/uploadvehiclephotos",
          "/agent/coveragedetailedview",
          "/agent/policyapproval",
          "/agent/uploadpolicy",
          "/agent/createquote/policydetails/createquote/",
          "/agent/createquote/coveragedetails/coveragecreate/",
          "/agent/leadedit",
          "/agent/createquote/accessories/accessoriescreate/",
          "/agent/quotelisting",
          "/agent/convertpolicy/customerinfo/edit/",
          "/agent/editquote/policydetails/quotedetails/",
          "/agent/quotedetailedit",
        ],
      },
      {
        name: "Clients",
        icon: <SvgAgentClientIcon color="#9DA4AE" />,
        path: "/agent/clientlisting",
        includes: [
          "/agent/clientlisting",
          "/agent/clientedit",
          "/agent/clientview/",
          "/agent/policydetailedview",
          "/agent/policydetailedview/accountview",
          "/agent/policydetailedviewonly",
          "/agent/claimrequest/claimdetails",
          "/agent/claimrequest/sendmail",
          "/agent/claimrequest/requestapproval/",
          "/agent/claimrequest/adjustersubmission",
          "/agent/claimrequest/settlementapproval",
          "/agent/claimrequest/settlementdetails/",
          "/agent/claimdetailedview/",
          "/agent/renewalquote/coveragedetails/coveragedetail/",
          "/agent/createquote/accessories/accessorirsdetails/",
          "/agent/createquote/ordersummaryquote",
          "/agent/endorsement/paymentconfirmation",
          "/agent/policy/paymentoptions",
          "/agent/endorsement/paymenterror/",
          "/agent/uploadendorsement",
          "/agent/endorsementdetailedview/123",
          "/agent/endorsement/paymentconfirmation",
          "/agent/endorsement/personaldetails",
          "/agent/uploadendorsement",
          "/agent/endorsementdetailedview/123",
          "/agent/endorsement/paymentconfirmation",
          "/agent/policy/paymentapproval",
          "/agent/renewal/waiting/",
          "/agent/renewalquote/accessories/accessorirsdetails/",
          "/agent/renewalquote/ordersummary",
          "/agent/endorsementdetailedview/",
          "/agent/endorsement/rejected/",
          "/agent/createquote/coveragedetails/coveragedetail/",
          "/agent/claimrejected",
          "/agent/claimdocumentupload",
          "/agent/endorsementdetailedviewonly/",
          "/agent/employee-benefit/client-policy-details",
        ],
      },
      {
        name: "Quotation",
        icon: <SvgQuotationIcon color="#9DA4AE" />,
        path: "/agent/Quotation",
        includes: ["/agent/Quotation",
          "/agent/employee-benefit/create-quote",
          "/agent/employee-benefit/create-quote-employeebulkupload",
          "/agent/employee-benefit/create-quote-Coverage-details",
          "/agent/employee-benefit/create-quote-order-summary",
          "/agent/employee-benefit/create-quote-quote-details",

        ],
      },
      {
        name: "Policy",
        icon: <SvgPolicyIcon color="#9DA4AE" />,
        path: "/agent/policy",
        includes: ["/agent/policy",
          "/agent/employee-benefit/policy-waiting-for-policy",
          "/agent/employee-benefit/policy-upload-policy"
        ],
      },
      {
        name: "Claims",
        icon: <SvgAgentItemsIcon color="#9DA4AE" />,
        path: "/agent/claim",
        includes: ["/agent/claim",
        ],
      },
      {
        name: "Open Items",
        icon: <SvgAgentItemsIcon color="#9DA4AE" />,
        path: "/agent/openitemslistdata",
        includes: [
          "/agent/openitemslistdata",
          "/agent/openitemslistdata",
          "/agent/openitems/expiringpolicy",
          "/agent/openitems/quotepending",

          "/agent/openitems/renewalrequest",
        ],
      },
      {
        name: "Payments",
        icon: <SvgAgentPaymentIcon color="#9DA4AE" />,
        path: "/agent/payments",
        includes: ["/agent/payments"],
      },      
    ],
  },
  {
    name: "Accounts",
    icon: <SvgAccountIcon />,
    submenu: [
      {
        id: 1,
        name: "Receipts",
        path: "/accounts/receipts",
        includes: [
          "/accounts/receipts/addreceipts",
          "/accounts/receipts/receiptdetailview",
          "/accounts/receipts/addreceiptedit",
          "/accounts/receipts/paymentdetails",
          "/accounts/receipts",
        ],
      },
      {
        id: 2,
        name: "Payment Voucher",
        path: "/accounts/paymentvoucher",
        includes: [
          "/accounts/paymentvoucher",
          "/accounts/paymentvoucher/createvoucher",
          "/accounts/paymentvoucher/detailview/",
          "/accounts/paymentvoucher/SpecificVoucher",
          "/accounts/paymentvoucher/bankdetailselection",
        ],
      },
      {
        id: 3,
        name: "Petty Cash",
        submenu: [
          {
            id: 1,
            name: "Initiate",
            path: "/accounts/pettycash/pettycashcodeinitiate",
            includes: [
              "/accounts/pettycash/pettycashcodeinitiate",
              "/accounts/pettycash/pettycashcodeinitiate/initiate",
              "/accounts/pettycash/PettyCashCodeDetails",
            ],
          },
          {
            id: 2,
            name: "Request",
            path: "/accounts/pettycash/pettycashrequest",
            includes: [
              "/accounts/pettycash/pettycashrequest",
              "/accounts/pettycash/addrequest/add/",
              "/accounts/pettycash/addrequesttable",
              "/accounts/pettycash/request",
              "/accounts/pettycash/editrequestform/edit/",
              "/accounts/pettycash/editrequestform/view/",
            ],
          },
          {
            id: 3,
            name: "Disbursement",
            path: "/accounts/pettycash/disbursement",
            includes: [
              "/accounts/pettycash/disbursement",
              "/accounts/pettycash/adddisbursement",
              "/accounts/pettycash/adddisbursementtable",
              "/accounts/pettycash/disbursementdetailview",
            ],
          },
          {
            id: 4,
            name: "Receipts",
            path: "/accounts/pettycash/receipts",
            includes: [
              "/accounts/pettycash/receipts",
              "/accounts/pettycash/addreceipts",
              "/accounts/pettycash/receiptlist",
              "/accounts/pettycash/addreceiptstable",
            ],
          },
          {
            id: 5,
            name: "Replenish",
            path: "/accounts/pettycash/replenish",
            includes: [
              "/accounts/pettycash/replenish",
              "/accounts/pettycash/addreplenish",
              "/accounts/pettycash/addreplenishtable",
              "/accounts/pettycash/replenishtdetailview",
            ],
          },
        ],
      },

      {
        id: 4,
        name: "Journal Voucher",
        path: "/accounts/journalvoucher",
        includes: [
          "/accounts/journalvoucher",
          "/accounts/journalvoucher/addjournalvoucture",
          "/accounts/journalvoucher/detailsjournalvocture/",
        ],
      },
      {
        id: 5,
        name: "Correction JV",
        path: "/accounts/correctionsjv/correctionsjvdetails",
        includes: ["/accounts/correctionsjv/correctionsjvdetails"],
      },
      {
        id: 6,
        name: "Reversal JV",
        path: "/accounts/reversaljv/reversaljvdetails",
        includes: ["/accounts/reversaljv/reversaljvdetails"],
      },
      {
        id: 7,
        name: "Remittance",
        submenu: [
          {
            id: 1,
            name: "Automated Processing",
            path: "/finance/remittance/automated/execute",
            includes: [
              "/finance/remittance/automated/execute",
              "/finance/remittance/automated/history",
            ],
          },
          {
            id: 2,
            name: "Tracking",
            path: "/finance/remittance/tracking/status",
            includes: [
              "/finance/remittance/tracking/status",
              "/finance/remittance/tracking/history",
            ],
          },
          {
            id: 3,
            name: "Statements",
            path: "/finance/remittance/statements/generate",
            includes: [
              "/finance/remittance/statements/generate",
              "/finance/remittance/statements/history",
            ],
          },
          {
            id: 4,
            name: "Settlement",
            path: "/finance/remittance/settlement/process",
            includes: [
              "/finance/remittance/settlement/process",
              "/finance/remittance/settlement/history",
            ],
          },
          {
            id: 5,
            name: "Reconciliation",
            path: "/finance/remittance/reconciliation",
            includes: [
              "/finance/remittance/reconciliation",
              "/finance/remittance/reconciliation/process",
              "/finance/remittance/reconciliation/exceptions",
            ],
          },
          {
            id: 6,
            name: "Bulk Processing",
            path: "/finance/remittance/bulkprocessing",
            includes: [
              "/finance/remittance/bulkprocessing",
              "/finance/remittance/bulkprocessing/upload",
              "/finance/remittance/bulkprocessing/history",
            ],
          },
          {
            id: 7,
            name: "Scheduling",
            path: "/finance/remittance/scheduling",
            includes: [
              "/finance/remittance/scheduling",
              "/finance/remittance/scheduling/calendar",
              "/finance/remittance/scheduling/jobs",
            ],
          },
          {
            id: 8,
            name: "Electronic Transfer",
            path: "/finance/remittance/electronictransfer",
            includes: [
              "/finance/remittance/electronictransfer",
              "/finance/remittance/electronictransfer/create",
              "/finance/remittance/electronictransfer/history",
            ],
          },
          {
            id: 9,
            name: "Approval Workflow",
            path: "/finance/remittance/approval",
            includes: [
              "/finance/remittance/approval",
              "/finance/remittance/approval/pending",
              "/finance/remittance/approval/history",
              "/finance/remittance/approval/delegation",
            ],
          },
          {
            id: 10,
            name: "Exception Management",
            path: "/finance/remittance/exceptions",
            includes: [
              "/finance/remittance/exceptions",
              "/finance/remittance/exceptions/resolve",
              "/finance/remittance/exceptions/history",
            ],
          },
          {
            id: 11,
            name: "Reports",
            path: "/finance/remittance/reports",
            includes: [
              "/finance/remittance/reports",
              "/finance/remittance/reports/generate",
              "/finance/remittance/reports/schedule",
            ],
          },
          {
            id: 12,
            name: "Agency Bill Processing",
            path: "/finance/remittance/agencybill",
            includes: [
              "/finance/remittance/agencybill",
              "/finance/remittance/agencybill/process",
              "/finance/remittance/agencybill/history",
            ],
          },
          {
            id: 13,
            name: "Direct Bill Processing",
            path: "/finance/remittance/directbill",
            includes: [
              "/finance/remittance/directbill",
              "/finance/remittance/directbill/process",
              "/finance/remittance/directbill/history",
            ],
          },
          {
            id: 14,
            name: "Adjustments",
            path: "/finance/remittance/adjustments",
            includes: [
              "/finance/remittance/adjustments",
              "/finance/remittance/adjustments/process",
              "/finance/remittance/adjustments/history",
            ],
          },
          {
            id: 15,
            name: "Notifications",
            path: "/finance/remittance/notifications",
            includes: [
              "/finance/remittance/notifications",
              "/finance/remittance/notifications/manage",
              "/finance/remittance/notifications/history",
            ],
          },
          {
            id: 16,
            name: "History",
            path: "/finance/remittance/history",
            includes: [
              "/finance/remittance/history",
              "/finance/remittance/history/view",
              "/finance/remittance/history/reports",
            ],
          },
          {
            id: 17,
            name: "Analytics",
            path: "/finance/remittance/analytics",
            includes: [
              "/finance/remittance/analytics",
              "/finance/remittance/analytics/dashboard",
              "/finance/remittance/analytics/reports",
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Reports",
    icon: <SvgReportsIcon />,
    submenu: [
      {
        id: 1,
        name: "Operational Reports",
        // path: "/reports/operationalreports",
        submenu: [
          {
            id: 1,
            name: "Production",
            path: "/reports/operationalreports/production",
            includes: ["/reports/operationalreports/production"],
          },
          {
            id: 2,
            name: "Claims",
            path: "/reports/operationalreports/claims",
            includes: ["/reports/operationalreports/claims"],
          },
          {
            id: 3,
            name: "Renewal",
            path: "/reports/operationalreports/renewal",
            includes: ["/reports/operationalreports/renewal"],
          },
          {
            id: 4,
            name: "Remittance",
            path: "/reports/operationalreports/remittance",
            includes: ["/reports/operationalreports/remittance"],
          },
          {
            id: 5,
            name: "Broker Commission",
            path: "/reports/operationalreports/brokercommision",
            includes: ["/reports/operationalreports/brokercommision"],
          },
        ],
      },
      {
        id: 2,
        name: "Financial Reports",
        // path: "/reports/operationalreports",
        submenu: [
          {
            id: 1,
            name: "SOA/Premium Receivable",
            path: "/reports/financialreports/soapremiumreceivable",
            includes: ["/reports/financialreports/soapremiumreceivable"],
          },
          {
            id: 2,
            name: "Collection Report",
            path: "/reports/financialreports/collectionreport",
            includes: ["/reports/financialreports/collectionreport"],
          },
          {
            id: 3,
            name: "Payables",
            path: "/reports/financialreports/Payables",
            includes: ["/reports/financialreports/Payables"],
          },
          {
            id: 4,
            name: "Journal",
            path: "/reports/financialreports/journal",
            includes: ["/reports/financialreports/journal"],
          },
          {
            id: 5,
            name: "Trail Balance",
            path: "/reports/financialreports/trailbalance",
            includes: ["/reports/financialreports/trailbalance"],
          },
        ],
      },
    ],
  },
];
